"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _EqualSizeFlexRow = _interopRequireDefault(require("../layout-wrappers/EqualSizeFlexRow"));
require("../../scss/blocks/PromotionRowBlock.module.scss");
function PromotionsRowBlock({
  children,
  gap = '1.5rem'
}) {
  return /*#__PURE__*/_react.default.createElement("promotions-row-block", null, /*#__PURE__*/_react.default.createElement(_EqualSizeFlexRow.default, {
    gap: gap
  }, children));
}
var _default = exports.default = PromotionsRowBlock;